import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function ReviewsPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Reviews",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/marketing/reviews" />
    </Container>
  );
}

export default ReviewsPage;